import type {ButtonProps} from "antd";

// Added Select and Ship icon-reader imports
import {MenuFoldOutlined, MenuUnfoldOutlined /* ShipOutlined */} from "@ant-design/icons";
import {BasicButton} from "#src/components/basic-button";
import VesselPopover from "#src/features/Vessels/VesselPopover";
// import VesselPopover from "#src/components/Vessels/VesselPopover";
import {useDeviceType} from "#src/hooks/use-device-type";
import {usePreferences} from "#src/hooks/use-preferences";
import {useLayout} from "#src/layout/hooks/use-layout";
import {GlobalSearch} from "#src/layout/widgets/global-search";
import {Logo} from "#src/layout/widgets/logo";
import {NotificationContainer} from "#src/layout/widgets/notification/notification-container";
import {Preferences} from "#src/layout/widgets/preferences";
import {useTabsStore} from "#src/store/tabs";
import {cn} from "#src/utils/cn";
import {theme as antdTheme, ConfigProvider, theme} from "antd";

import {headerHeight} from "../constants";
import {FullscreenButton} from "./components/fullscreen-button";
// import { LanguageButton } from "./components/language-button";
import {ThemeButton} from "./components/theme-button";
import {UserMenu} from "./components/user-menu";

export interface LayoutHeaderProps {
	className?: string
	children?: React.ReactNode
}

const buttonProps: ButtonProps = {
	size: "large",
	className: "px-[11px]",
};

export default function LayoutHeader({className, children}: LayoutHeaderProps) {
	const {
		token: {colorBgContainer},
	} = theme.useToken();
	const {
		sidebarCollapsed,
		setPreferences,
		isDark,
		sidebarTheme,
	} = usePreferences();
	const {isMobile} = useDeviceType();
	const isMaximize = useTabsStore(state => state.isMaximize);
	const {isTopNav, isMixedNav} = useLayout();
	const isFixedDarkTheme = isDark || (sidebarTheme === "dark" && (isMixedNav || isTopNav));

	return (
		<ConfigProvider
			theme={{
				algorithm: isFixedDarkTheme
					? antdTheme.darkAlgorithm
					: antdTheme.defaultAlgorithm,
			}}
		>
			<header
				className={cn(
					"flex-shrink-0 flex gap-5 justify-between items-center transition-all md:px-1",
					{"overflow-hidden": isMaximize},
					className,
				)}
				style={{
					background: colorBgContainer,
					height: isMaximize ? 0 : headerHeight,
					// borderBottom: `1px solid ${isDark ? "#303030" : "#f0f0f0"}`,
				}}
			>
				<div className="flex items-center">
					{isMobile && (
						<BasicButton
							type="text"
							icon={sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
							onClick={() => setPreferences("sidebarCollapsed", !sidebarCollapsed)}
							className="h-full mx-2"
							size="large"
						/>
					)}
					{/* Vessel Selector Dropdown */}
					<VesselPopover
						onChange={value => console.log("Vessel changed:", value)}
						defaultValue="v1"
					/>
				</div>
				<div className="flex items-center">
					{isMobile && (
						<BasicButton
							type="text"
							icon={sidebarCollapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
							onClick={() => setPreferences("sidebarCollapsed", !sidebarCollapsed)}
							className="h-full mx-2"
							size="large"
						/>
					)}
					{!isTopNav && (<Logo sidebarCollapsed={false}/>)}
				</div>

				<div className="flex items-center flex-grow h-full overflow-hidden">
					{children}
				</div>

				<div className="flex items-center">
					<GlobalSearch/>
					<Preferences {...buttonProps} />
					<ThemeButton {...buttonProps} />
					{/* <LanguageButton {...buttonProps} /> */}
					<FullscreenButton {...buttonProps} target={document.documentElement}/>
					<NotificationContainer {...buttonProps} />
					<UserMenu/>
				</div>
			</header>
		</ConfigProvider>
	);
}
